import { Box, Grid, Stack } from "@mui/system";
import {
  Typography,
  Chip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Alert,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CodeIcon from "@mui/icons-material/Code";
import BrushIcon from "@mui/icons-material/Brush";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import { FuturisticHeader } from "../../FuturisticHeader";
import VerticalLinearStepper from "../VerticalLinearStepper";
import { LiveCodeBlock } from "../../LiveCodeBlock";

export const Card = () => {
  return (
    <>
      <style>
        {`
            @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;700&display=swap');
            @import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css');

            .challenge-card {
                width: 320px;
                background: white;
                border-radius: 20px;
                overflow: hidden;
                box-shadow: 0 10px 30px rgba(0,0,0,0.15);
                position: relative;
                font-family: 'Poppins', sans-serif;
                color: #333;
                text-align: left;
                margin: auto;
            }

            .challenge-img {
                width: 100%;
                height: 180px;
                object-fit: cover;
                display: block;
            }

            .challenge-badge {
                position: absolute;
                top: 15px;
                right: 15px;
                background-color: #ff3b30;
                color: white;
                padding: 4px 10px;
                border-radius: 6px;
                font-weight: bold;
                font-size: 12px;
                box-shadow: 0 2px 4px rgba(0,0,0,0.2);
                z-index: 2;
            }

            .challenge-content { padding: 20px; }
            .challenge-h2 { margin: 5px 0; font-size: 22px; color: #1d1d1f; }
            .challenge-cat { text-transform: uppercase; font-size: 10px; color: #999; letter-spacing: 1px; }

            .challenge-table { width: 100%; font-size: 13px; margin: 15px 0; border-collapse: collapse; }
            .challenge-table td { border-bottom: 1px solid #eee; padding: 6px 0; }
            .challenge-table td:last-child { font-weight: bold; text-align: right; }

            .challenge-ul { list-style: none; padding: 0; margin: 15px 0; font-size: 13px; }
            .challenge-ul li { margin-bottom: 4px; display: flex; align-items: center; }
            .challenge-ul li::before {
                content: "\\f00c"; 
                font-family: "Font Awesome 6 Free";
                font-weight: 900;
                color: #4cd964;
                margin-right: 8px;
            }

            .challenge-price-box {
                display: flex; justify-content: space-between; align-items: center; margin-top: 15px; padding-top: 15px; border-top: 1px dashed #eee;
            }
            .challenge-price { font-size: 20px; font-weight: bold; }
            .challenge-price::before { content: '€ '; font-size: 14px; vertical-align: top; }

            .challenge-btn {
                background: #007aff; color: white; padding: 8px 16px; border-radius: 50px; text-decoration: none; font-size: 13px; transition: 0.2s;
            }
            .challenge-btn:hover { background: #005ecb; transform: scale(1.05); }
          `}
      </style>

      <div className="challenge-card">
        <span className="challenge-badge">-20% SALE</span>
        <img
          src="https://images.unsplash.com/photo-1606144042614-b2417e99c4e3?q=80&w=1000&auto=format&fit=crop"
          alt="Sony Headphones"
          className="challenge-img"
        />

        <div className="challenge-content">
          <div className="challenge-cat">Gameconsoles</div>
          <h2 className="challenge-h2">Sony PlayStation 5</h2>

          <div
            style={{ color: "#ffc107", fontSize: "12px", marginBottom: "10px" }}
          >
            <i className="fas fa-star"></i>
            <i className="fas fa-star"></i>
            <i className="fas fa-star"></i>
            <i className="fas fa-star"></i>
            <i className="fas fa-star-half-alt"></i>
            <span style={{ color: "#ccc", marginLeft: 5 }}>(450)</span>
          </div>

          <table className="challenge-table">
            <tbody>
              <tr>
                <td>Resolutie</td>
                <td>4K/8K</td>
              </tr>
              <tr>
                <td>Gewicht</td>
                <td>4,5kg</td>
              </tr>
            </tbody>
          </table>

          <ul className="challenge-ul">
            <li>Ultra High-speed SSD</li>
            <li>Backwards compatability</li>
          </ul>

          <div className="challenge-price-box">
            <span className="challenge-price">479,00</span>
            <a href="#!" className="challenge-btn">
              In winkelwagen <i className="fas fa-shopping-cart"></i>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

// --- COMPONENT 2: CHALLENGE PART 1 (CARD BOUWEN) ---
export const KdappontCssChallenge = () => {
  return (
    <Grid container columns={12} spacing={4} sx={{ height: "100%" }}>
      {/* LINKS: HET EINDRESULTAAT */}
      <Grid
        size={4}
        sx={{
          bgcolor: "#f0f2f5",
          borderRadius: 4,
          p: 4,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border: "2px dashed #ccc",
          position: "relative",
        }}
      >
        <Typography
          variant="caption"
          sx={{ position: "absolute", top: 10, left: 10, color: "#999" }}
        >
          DOEL (Preview)
        </Typography>
        <Card />
      </Grid>

      {/* RECHTS: HET STAPPENPLAN */}
      <Grid
        size={8}
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          height: "100%",
          overflowY: "auto",
        }}
      >
        <Box>
          <Typography
            variant="h5"
            sx={{ fontWeight: "bold", color: "#007aff", mb: 1 }}
          >
            🏆 Deel 1: De Product Card
          </Typography>
          <Accordion
            defaultExpanded
            disableGutters
            elevation={0}
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: "8px !important",
              mb: 1,
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography sx={{ fontWeight: "bold" }}>
                1. De Kaart (Container)
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ bgcolor: "#fafafa" }}>
              <Grid container spacing={1}>
                <Stack gap={1} direction="row">
                  <Chip
                    color="info"
                    icon={<CodeIcon />}
                    label="width: 320px"
                    size="medium"
                  />
                  <Chip
                    color="info"
                    icon={<CodeIcon />}
                    label="margin: auto"
                    size="medium"
                  />
                  <Chip
                    color="info"
                    icon={<BrushIcon />}
                    label="box-shadow"
                    size="medium"
                  />
                </Stack>
              </Grid>
            </AccordionDetails>
          </Accordion>

          <Accordion
            disableGutters
            elevation={0}
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: "8px !important",
              mb: 1,
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography sx={{ fontWeight: "bold" }}>
                2. Header & Badge
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ bgcolor: "#fafafa" }}>
              <Grid container spacing={1}>
                <Stack gap={1} direction="row">
                  <Chip
                    color="info"
                    icon={<CodeIcon />}
                    label="<img /> object-fit: cover"
                    size="medium"
                  />
                  <Chip
                    color="info"
                    icon={<CodeIcon />}
                    label="position: absolute"
                    size="medium"
                  />
                  <Chip
                    color="info"
                    icon={<CodeIcon />}
                    label="top: 15px; right: 15px"
                    size="medium"
                  />
                </Stack>
              </Grid>
            </AccordionDetails>
          </Accordion>

          <Accordion
            disableGutters
            elevation={0}
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: "8px !important",
              mb: 1,
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography sx={{ fontWeight: "bold" }}>
                3. Specificaties & Features
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ bgcolor: "#fafafa" }}>
              <Grid container spacing={1}>
                <Stack gap={1} direction="row">
                  <Chip
                    color="info"
                    icon={<CodeIcon />}
                    label="<table>"
                    size="medium"
                  />
                  <Chip
                    color="info"
                    icon={<CodeIcon />}
                    label="<ul> <li>"
                    size="medium"
                  />
                  <Chip
                    color="info"
                    icon={<CodeIcon />}
                    label="::before { content: '✓' }"
                    size="medium"
                  />
                </Stack>
              </Grid>
            </AccordionDetails>
          </Accordion>

          <Accordion
            disableGutters
            elevation={0}
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: "8px !important",
              mb: 1,
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography sx={{ fontWeight: "bold" }}>
                4. De Actie Knop
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ bgcolor: "#fafafa" }}>
              <Grid container spacing={1}>
                <Stack gap={1} direction="row">
                  <Chip
                    color="info"
                    icon={<CodeIcon />}
                    label="display: inline-block"
                    size="medium"
                  />
                  <Chip
                    color="info"
                    icon={<CodeIcon />}
                    label="background-color: blue"
                    size="medium"
                  />
                  <Chip
                    color="info"
                    icon={<CodeIcon />}
                    label=":hover { ... }"
                    size="medium"
                  />
                </Stack>
              </Grid>
            </AccordionDetails>
          </Accordion>
        </Box>
        <Alert severity="info">
          <b>Overige vereisten:</b> Font "Poppins" (Google Fonts) & Afbeelding
          van Unsplash.
        </Alert>
      </Grid>
    </Grid>
  );
};

// --- COMPONENT 3: CHALLENGE PART 2 (HEADER/FOOTER) ---
export const KdappontCssChallengePart2 = () => {
  return (
    <Grid container columns={12} spacing={4} sx={{ height: "100%" }}>
      {/* LINKS: HET VOORBEELD (BREED) */}
      <Grid
        size={8}
        sx={{
          bgcolor: "#e9ecef",
          borderRadius: 4,
          overflow: "hidden",
          border: "2px dashed #ccc",
          position: "relative",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography
          variant="caption"
          sx={{
            position: "absolute",
            top: 10,
            left: 10,
            color: "#999",
            zIndex: 10,
          }}
        >
          DOEL (Full Page Layout)
        </Typography>

        <style>
          {`
            .mock-body { font-family: 'Poppins', sans-serif; color: #333; height: 100%; display: flex; flex-direction: column; }
            .mock-a { text-decoration: none; color: inherit; transition: 0.2s; }
            .mock-ul { list-style: none; padding: 0; margin: 0; }
            
            /* HEADER */
            .mock-header {
                background: white; height: 70px; display: flex; align-items: center; justify-content: space-between;
                padding: 0 40px; box-shadow: 0 4px 15px rgba(0,0,0,0.05); position: relative; z-index: 100;
            }
            .mock-logo { font-weight: 900; font-size: 20px; color: #007aff; }

            /* NAV */
            .mock-nav-list { display: flex; gap: 30px; height: 100%; align-items: center; }
            .mock-nav-item { position: relative; height: 100%; display: flex; align-items: center; }
            .mock-nav-link { font-weight: 600; font-size: 14px; color: #555; cursor: pointer; }
            .mock-nav-link:hover { color: #007aff; }

            /* DROPDOWN */
            .mock-dropdown {
              list-style:none;
                display: none; position: absolute; top: 20px; left: -20px; background: white;
                min-width: 180px; box-shadow: 0 10px 20px rgba(0,0,0,0.1); border-radius: 12px; padding: 10px 0; border: 1px solid #eee;
            }
            .mock-dropdown li a { display: block; padding: 10px 20px; font-size: 13px; color: #666; }
            .mock-dropdown li a:hover { background: #f5faff; color: #007aff; }
            .mock-nav-item:hover .mock-dropdown { display: block; }

            /* MAIN & FOOTER */
            .mock-main { flex-grow: 1; padding: 40px; display: flex; justify-content: center; align-items: center; }
            .mock-footer {
                background: white; padding: 40px; box-shadow: 0 -5px 20px rgba(0,0,0,0.05);
                display: flex; justify-content: space-between; font-size: 13px; color: #777;
            }
            .mock-footer-col h4 { color: #333; margin-bottom: 15px; font-size: 14px; }
            .mock-footer-col ul li { margin-bottom: 8px; }
          `}
        </style>

        <div className="mock-body">
          <header className="mock-header">
            <div className="mock-logo">
              <i className="fas fa-gamepad"></i> GAMESTORE
            </div>
            <nav>
              <ul className="mock-nav-list">
                <li className="mock-nav-item">
                  <a className="mock-nav-link" href="#!">
                    Home
                  </a>
                </li>
                <li className="mock-nav-item">
                  <a className="mock-nav-link" href="#!">
                    Consoles{" "}
                    <i
                      className="fas fa-chevron-down"
                      style={{ fontSize: 10, marginLeft: 4 }}
                    ></i>
                  </a>
                  <ul className="mock-dropdown">
                    <li>
                      <a href="#!">Playstation 5</a>
                    </li>
                    <li>
                      <a href="#!">Xbox Series X</a>
                    </li>
                  </ul>
                </li>
                <li className="mock-nav-item">
                  <a className="mock-nav-link" href="#!">
                    Games
                  </a>
                </li>
              </ul>
            </nav>
          </header>

          <main className="mock-main">
            <div style={{ transform: "scale(0.85)" }}>
              <Card />
            </div>
          </main>

          <footer className="mock-footer">
            <div className="mock-footer-col">
              <h4>Over Gamestore</h4>
              <p style={{ maxWidth: 200, lineHeight: 1.6 }}>
                Dé plek voor next-gen gaming gear.
              </p>
            </div>
            <div className="mock-footer-col">
              <h4>Klantenservice</h4>
              <ul className="mock-ul">
                <li>
                  <a href="#!" className="mock-a">
                    Bestelling volgen
                  </a>
                </li>
                <li>
                  <a href="#!" className="mock-a">
                    Retourneren
                  </a>
                </li>
              </ul>
            </div>
            <div className="mock-footer-col">
              <h4>Volg ons</h4>
              <ul className="mock-ul">
                <li>
                  <a href="#!" className="mock-a">
                    <i className="fab fa-instagram"></i> Instagram
                  </a>
                </li>
              </ul>
            </div>
          </footer>
        </div>
      </Grid>

      {/* RECHTS: DE UITLEG (SMAL) */}
      <Grid
        size={4}
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          height: "100%",
          overflowY: "auto",
        }}
      >
        <Box>
          <Typography
            variant="h5"
            sx={{ fontWeight: "bold", color: "#007aff" }}
          >
            🚀 Deel 2: Full Layout
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Bouw de webshop om de kaart heen.
          </Typography>
        </Box>

        <Accordion
          defaultExpanded
          disableGutters
          elevation={0}
          sx={{
            border: "1px solid #e0e0e0",
            borderRadius: "8px !important",
            mb: 1,
          }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography sx={{ fontWeight: "bold", fontSize: "0.9rem" }}>
              1. Header & Flexbox
            </Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ bgcolor: "#fafafa" }}>
            <Typography variant="caption" paragraph>
              Logo links, Menu rechts.
            </Typography>
            <Stack gap={1}>
              <Chip icon={<CodeIcon />} label="display: flex" size="small" />
              <Chip
                icon={<CodeIcon />}
                label="justify-content: space-between"
                size="small"
              />
            </Stack>
          </AccordionDetails>
        </Accordion>

        <Accordion
          disableGutters
          elevation={0}
          sx={{
            border: "1px solid #e0e0e0",
            borderRadius: "8px !important",
            mb: 1,
          }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography sx={{ fontWeight: "bold", fontSize: "0.9rem" }}>
              2. De Dropdown (Tricky!)
            </Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ bgcolor: "#fafafa" }}>
            <Stack gap={1}>
              <LiveCodeBlock
                code={`<ul>
      <li>
          <a href="#!">Home</a>
          Consoles
          <ul> <!-- standaard hidden! -->
            <li>
              <a href="#!">PlayStation 5</a>
            </li>
          </ul>
          <a href="#!">Games</a>
      </li>
</ul>`}
              />
            </Stack>
          </AccordionDetails>
        </Accordion>

        <Accordion
          disableGutters
          elevation={0}
          sx={{
            border: "1px solid #e0e0e0",
            borderRadius: "8px !important",
            mb: 1,
          }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography sx={{ fontWeight: "bold", fontSize: "0.9rem" }}>
              3. Footer Columns
            </Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ bgcolor: "#fafafa" }}>
            <Stack gap={1} direction="row" flexWrap="wrap">
              <Chip
                icon={<ViewColumnIcon />}
                label="display: flex"
                size="small"
              />
              <Chip
                icon={<CodeIcon />}
                label="justify-content: space-between"
                size="small"
              />
            </Stack>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </Grid>
  );
};

// --- MAIN LESSON COMPONENT ---
export const KdappontCssLesson6 = () => {
  return (
    <VerticalLinearStepper
      steps={[
        {
          label: "👨🏼‍🏫 Voor vandaag",
          description: ``,
          content: <FuturisticHeader items={["🏆", "CSS Challenge", "🏆"]} />,
        },
        {
          label: "Challenge 🏆 Part 1/2",
          description: `Bouw de Product Card`,
          content: <KdappontCssChallenge />,
        },
        {
          label: "Challenge 🏆 Part 2/2",
          description: ``,
          content: <KdappontCssChallengePart2 />,
        },
      ]}
    />
  );
};
